function TranslateFilter(translateService){
    return function(input, args){
        return translateService.translate(input, args);
    };
}

TranslateFilter.$inject = ['translateService'];

module.exports = TranslateFilter;


// WEBPACK FOOTER //
// ./src/shared/utils/translate.filter.js